module.exports = __webpack_public_path__ + "static/media/Icon-Arrowdown.83397e28.svg";